<div class="es" [class]="'es--' + size">
  <span class="bk-sym es__icon" aria-hidden="true">{{ glyph }}</span>

  <!-- Polite live region: a search or filter that empties the list is announced. -->
  <div class="es__text" role="status" aria-atomic="true">
    <p class="es__line">{{ line }}</p>
    @if (subline) {
      <p class="es__hint">{{ subline }}</p>
    }
  </div>

  <div class="es__actions">
    @if (showClear) {
      <button type="button" class="bk-btn bk-btn--ghost" (click)="clear.emit()">
        {{ clearLabel }}
      </button>
    }
    @if (actionLabel) {
      <button type="button" class="bk-btn bk-btn--primary" (click)="action.emit()">
        @if (actionIcon) {
          <span class="bk-sym" aria-hidden="true">{{ actionIcon }}</span>
        }
        {{ actionLabel }}
      </button>
    }
    <ng-content></ng-content>
  </div>
</div>
